// extracted by mini-css-extract-plugin
export default {"root":"DownloadMobileAppBanner_root__7V3yH"};